(function () {
  var MOBILE_MEDIA_QUERY = "(max-width: 768px)";
  var HIDDEN_CLASS = "kl-teaser--home-hidden";
  var HIDING_CLASS = "kl-teaser--home-hiding";
  var KL_TEASER_SELECTOR = '[class^="kl-teaser"],[class*=" kl-teaser"]';
  var ZONE_START_SELECTOR = ".fitness-carousel__viewport";
  var ZONE_END_SELECTOR = ".home-product-list__cards";
  var HIDE_AHEAD_PX = 80;
  var HIDE_DURATION_MS = 350;

  var scrollTicking = false;
  var lateInjectPollId = null;
  var teaserHidden = false;

  function isMobile() {
    return window.matchMedia(MOBILE_MEDIA_QUERY).matches;
  }

  function getKlTeaserElements() {
    return document.querySelectorAll(KL_TEASER_SELECTOR);
  }

  function getCarouselZone() {
    var zoneStart = document.querySelector(ZONE_START_SELECTOR);
    var zoneEnd = document.querySelector(ZONE_END_SELECTOR);

    if (!zoneStart || !zoneEnd) {
      return null;
    }

    return {
      top: zoneStart.getBoundingClientRect().top,
      bottom: zoneEnd.getBoundingClientRect().bottom,
    };
  }

  function isAboveCarouselZone(zone, viewHeight) {
    return zone.top > viewHeight + HIDE_AHEAD_PX;
  }

  function shouldHideTeaser() {
    if (!isMobile()) {
      return false;
    }

    var zone = getCarouselZone();

    if (!zone) {
      return false;
    }

    var viewHeight = window.innerHeight || document.documentElement.clientHeight;

    if (isAboveCarouselZone(zone, viewHeight)) {
      return false;
    }

    return true;
  }

  function showTeaser(teaser, animate) {
    if (!teaser.classList.contains(HIDDEN_CLASS) && !teaser.classList.contains(HIDING_CLASS)) {
      return;
    }

    if (!animate) {
      teaser.classList.remove(HIDING_CLASS);
      teaser.classList.remove(HIDDEN_CLASS);
      return;
    }

    teaser.classList.remove(HIDDEN_CLASS);
    teaser.classList.add(HIDING_CLASS);

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        teaser.classList.remove(HIDING_CLASS);
      });
    });
  }

  function showAllTeasers(animate) {
    var teasers = getKlTeaserElements();
    var shouldAnimate = animate && teaserHidden;

    for (var i = 0; i < teasers.length; i++) {
      showTeaser(teasers[i], shouldAnimate);
    }

    teaserHidden = false;
  }

  function hideTeaser(teaser, animate) {
    if (teaser.classList.contains(HIDDEN_CLASS) || teaser.classList.contains(HIDING_CLASS)) {
      return;
    }

    if (!animate) {
      teaser.classList.remove(HIDING_CLASS);
      teaser.classList.add(HIDDEN_CLASS);
      return;
    }

    teaser.classList.add(HIDING_CLASS);

    var finishHide = function () {
      teaser.classList.remove(HIDING_CLASS);
      teaser.classList.add(HIDDEN_CLASS);
    };

    var onTransitionEnd = function (event) {
      if (event.target !== teaser || event.propertyName !== "opacity") {
        return;
      }

      teaser.removeEventListener("transitionend", onTransitionEnd);
      window.clearTimeout(fallbackId);
      finishHide();
    };

    var fallbackId = window.setTimeout(function () {
      teaser.removeEventListener("transitionend", onTransitionEnd);
      finishHide();
    }, HIDE_DURATION_MS + 50);

    teaser.addEventListener("transitionend", onTransitionEnd);
  }

  function hideAllTeasers(animate) {
    var teasers = getKlTeaserElements();

    for (var i = 0; i < teasers.length; i++) {
      hideTeaser(teasers[i], animate);
    }

    teaserHidden = true;
  }

  function syncTeaserVisibility() {
    if (!isMobile()) {
      showAllTeasers();
      return;
    }

    var hide = shouldHideTeaser();

    if (hide) {
      hideAllTeasers(!teaserHidden);
      return;
    }

    showAllTeasers(teaserHidden);
  }

  function onScrollOrResize() {
    if (!scrollTicking) {
      scrollTicking = true;

      window.requestAnimationFrame(function () {
        scrollTicking = false;
        syncTeaserVisibility();
      });
    }
  }

  function startLateInjectPoll() {
    if (lateInjectPollId) {
      return;
    }

    var pollCount = 0;
    lateInjectPollId = window.setInterval(function () {
      pollCount += 1;
      syncTeaserVisibility();

      if (pollCount >= 10 || getKlTeaserElements().length) {
        window.clearInterval(lateInjectPollId);
        lateInjectPollId = null;
      }
    }, 2000);
  }

  function init() {
    if (!document.querySelector(ZONE_START_SELECTOR) || !document.querySelector(ZONE_END_SELECTOR)) {
      return;
    }

    window.addEventListener("scroll", onScrollOrResize, { passive: true });
    window.addEventListener("resize", onScrollOrResize);

    var mobileMedia = window.matchMedia(MOBILE_MEDIA_QUERY);
    var onMobileChange = function () {
      syncTeaserVisibility();
    };

    if (mobileMedia.addEventListener) {
      mobileMedia.addEventListener("change", onMobileChange);
    } else if (mobileMedia.addListener) {
      mobileMedia.addListener(onMobileChange);
    }

    syncTeaserVisibility();
    startLateInjectPoll();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
